<template>
  <Teleport to="body">
    <div class="modal-backdrop" :class="{ 'modal-backdrop-draggable': draggable && posX !== null }" :style="{ zIndex: zIndexReal }">
      <div ref="modalRef" class="modal-container shadow" role="dialog" aria-modal="true" :class="tamanhoClass" :aria-labelledby="configuracao.titulo" :style="modalStyle">

      <!-- Cabeçalho -->
      <header
        class="modal-header"
        :class="{ 'cursor-grab': draggable, 'cursor-grabbing': draggable && dragging }"
        @mousedown.self="iniciarArrasto"
      >
        <h5 class="modal-title" :id="configuracao.titulo">{{ configuracao.titulo || 'Buscar Registro' }}</h5>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn-close btn-close-white modal-size-btn"
            :disabled="tamanhoAtualIndex === 0"
            @click="diminuirTamanho"
            title="Diminuir modal (atual: {{ tamanhoAtual.toUpperCase() }})"
            aria-label="Diminuir modal">
            <i class="bi bi-fullscreen-exit"></i>
          </button>
          <button type="button" class="btn-close btn-close-white modal-size-btn"
            :disabled="tamanhoAtualIndex === tamanhosDisponiveis.length - 1"
            @click="aumentarTamanho"
            title="Aumentar modal (atual: {{ tamanhoAtual.toUpperCase() }})"
            aria-label="Aumentar modal">
            <i class="bi bi-arrows-fullscreen"></i>
          </button>
          <button type="button" class="btn-close btn-close-white" @click="fechar" aria-label="Fechar"></button>
        </div>
      </header>

      <!-- Corpo -->
      <div class="modal-body">
        <div class="filtros-container">
          <div class="filtros-corpo">
            <div class="filtros-grid">
              <template v-for="filtro in configuracao.camposFiltro" :key="filtro.model">
                <!-- GUARDIÃO: Ocultar visualmente os filtros do tipo hidden -->
                <template v-if="filtro.tipo !== 'hidden'">
                  <!-- Filtro de Data -->
                  <div v-if="filtro.tipo === 'date'" class="filtro-item filtro-data">
                    <label :for="`filtro-${filtro.model}`" class="form-label">{{ filtro.label }}</label>
                    <div class="input-group">
                      <select class="form-select filtro-operador" v-model="valoresFiltro[filtro.model + '_op']">
                        <option value="=">=</option>
                        <option value="&#60;">&#60;</option>
                        <option value="&#60;=">&#60;=</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="&#60;&#62;">&#60;&#62;</option>
                      </select>
                      <input
                        type="date"
                        class="form-control"
                        :id="`filtro-${filtro.model}`"
                        v-model="valoresFiltro[filtro.model]"
                        @keyup.enter="executarBusca(1)"
                      >
                    </div>
                  </div>
                  <!-- Filtro de Select -->
                  <div v-else-if="filtro.tipo === 'select'" class="filtro-item">
                    <label :for="`filtro-${filtro.model}`" class="form-label">{{ filtro.label }}</label>
                    <select
                      class="form-select"
                      :id="`filtro-${filtro.model}`"
                      v-model="valoresFiltro[filtro.model]"
                      @change="executarBusca(1)"
                    >
                      <option value="">Todos</option>
                      <option v-for="opt in (opcoesSelect[filtro.model] || [])" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                      </option>
                    </select>
                  </div>
                  <!-- Filtro do tipo CampoBuscaLista (listas com busca modal) -->
                  <div v-else-if="filtro.tipo === 'listabusca'" class="filtro-item">
                    <label class="form-label">{{ filtro.label }}</label>
                    <CampoBuscaLista
                      :id="filtro.model"
                      :label="filtro.label"
                      v-model="valoresFiltro[filtro.model]"
                      :tabela="filtro.tabela || configuracao.tabela"
                      :prefixo="filtro.prefixo"
                      hide-label
                      @selecionado="onFiltroListaSelecionado(filtro.model, $event)"
                    />
                  </div>
                  <!-- Filtro do tipo CampoBusca (busca por entidade com modal) -->
                  <div v-else-if="filtro.tipo === 'campobusca'" class="filtro-item">
                    <label class="form-label">{{ filtro.label }}</label>
                    <CampoBusca
                      :id="filtro.model"
                      v-model="valoresFiltro[filtro.model]"
                      :configuracao-busca="filtro.configuracaoBusca"
                      hide-label
                      @selecionado="onFiltroCampoBuscaSelecionado(filtro.model, $event)"
                    />
                  </div>
                  <!-- Filtro de Texto/Número -->
                  <div v-else class="filtro-item">
                    <label :for="`filtro-${filtro.model}`" class="form-label">{{ filtro.label }}</label>
                    <input
                      :type="filtro.tipo || 'text'"
                      class="form-control"
                      :id="`filtro-${filtro.model}`"
                      v-model="valoresFiltro[filtro.model]"
                      @keyup.enter="executarBusca(1)"
                    >
                  </div>
                </template>
              </template>
            </div>
            <!-- Botão de Pesquisa fixo Ã  direita -->
            <div class="filtro-botao-wrapper">
              <button type="button" class="btn btn-primary" @click="executarBusca(1)" :disabled="isLoading">
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Pesquisar
              </button>
            </div>
          </div>
        </div>

        <hr class="my-4 border-secondary-subtle">

        <!-- Resultados -->
        <div class="resultados-container">
          <div class="d-flex justify-content-end text-muted fst-italic small mb-2">
            <i class="bi bi-info-circle me-1"></i>
            <span v-if="selecaoMultipla">Marque os itens desejados e clique em Confirmar</span>
            <span v-else>Escolha selecionando um item da lista</span>
          </div>

          <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>

          <div v-else-if="erroBusca" class="alert alert-danger border-0 shadow-sm">
            {{ erroBusca }}
          </div>

          <div v-else-if="resultadosOrdenados.length > 0">
            <AdminTable
              :columns="colunasMapeadas"
              :data="resultadosOrdenados"
              v-model:sort-field="sortField"
              v-model:sort-order="sortOrder"
              :row-class="rowClassJaSelecionado"
              @sort-change="onSortChange"
              @row-click="onRowClick"
            >
              <template #checkbox="{ row }">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="itensSelecionados.has(String(row[idField]))"
                  @click.stop
                  @change="toggleItemSelecao(row)"
                />
              </template>
            </AdminTable>
          </div>

          <div v-else class="alert alert-secondary text-center border-0 shadow-sm">
            Nenhum resultado encontrado.
          </div>
        </div>
      </div>

      <!-- Rodapé com Itens Selecionados + Paginação -->
      <footer class="modal-footer">
        <div class="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
          <!-- Itens selecionados — seleção VIVA do modal (reflete marcações e desmarcações) -->
          <div v-if="itensSelecionadosLista.length > 0" class="w-100 mb-2">
            <div class="d-flex align-items-center gap-2 mb-1">
              <small class="text-muted fw-semibold">✅ Selecionado{{ itensSelecionadosLista.length > 1 ? 's' : '' }} ({{ itensSelecionadosLista.length }}):</small>
            </div>
            <div class="table-responsive ja-selecionados-table">
              <table class="table table-sm table-borderless mb-0">
                <thead>
                  <tr>
                    <th v-for="col in colunasMapeadas" :key="col.field" class="small text-muted fw-semibold" :style="col.width ? { width: col.width + 'px' } : {}">
                      {{ col.label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in itensSelecionadosLista" :key="'ja-' + idx">
                    <td v-for="col in colunasMapeadas" :key="col.field" class="small py-1">
                      <template v-if="col.slotName === 'checkbox'">
                        <i class="bi bi-check-circle-fill text-success"></i>
                      </template>
                      <template v-else>
                        {{ col.formatter ? col.formatter(item[col.field], item) : item[col.field] }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr class="my-1">
          </div>

          <div class="d-flex flex-wrap align-items-center gap-4">
            <span class="text-body-secondary small">
              Página <strong>{{ paginacao.CurrentPage || 0 }}</strong> de <strong>{{ paginacao.TotalPages || 0 }}</strong>
              <span class="d-none d-sm-inline">(Total: {{ paginacao.TotalCount || 0 }} registos)</span>
            </span>

            <div class="d-flex align-items-center gap-2">
              <label class="text-body-secondary small mb-0 d-none d-sm-inline">Itens por página:</label>
              <select
                class="form-select form-select-sm w-auto"
                :value="paginacao.PageSize"
                @change="onPageSizeChange"
              >
                <option v-for="opcao in opcoesTamanho" :key="opcao" :value="opcao">{{ opcao }}</option>
              </select>
            </div>
          </div>

          <div class="d-flex align-items-center gap-2">
            <button
              v-if="selecaoMultipla"
              type="button"
              class="btn btn-primary btn-sm"
              @click="confirmarSelecao"
              :disabled="itensSelecionados.size === 0"
            >
              <i class="bi bi-check-lg me-1"></i>
              Confirmar seleção ({{ itensSelecionados.size }})
            </button>

            <div class="btn-group btn-group-sm">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="executarBusca(paginacao.CurrentPage - 1)"
                :disabled="!paginacao.HasPrevious"
              >
                <i class="bi bi-chevron-left"></i>
                <span class="d-none d-sm-inline"> Anterior</span>
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm ms-2"
                @click="executarBusca(paginacao.CurrentPage + 1)"
                :disabled="!paginacao.HasNext"
              >
                <span class="d-none d-sm-inline">Próxima </span>
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue'
import api from '@/services/api'
import AdminTable from '../grid/AdminTable.vue'
import CampoBuscaLista from '../campos/CampoBuscaLista.vue'
import CampoBusca from '../campos/CampoBusca.vue'
import { useResolverListas } from '@/composables/useResolverListas'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const props = defineProps({
  configuracao: {
    type: Object,
    required: true
  },
  tamanho: {
    type: String,
    default: 'lg' // xs, sm, lg, xl, xxl
  },
  // Override opcional do z-index (piso). Quando null, usa o registry central.
  zIndexBase: {
    type: Number,
    default: null
  },
  selecaoMultipla: {
    type: Boolean,
    default: false
  },
  itensJaSelecionados: {
    type: Array,
    default: () => []
  },
  onShowNotification: {
    type: Function,
    default: null
  },
  draggable: {
    type: Boolean,
    default: true
  }
})

// --- Empilhamento (z-index) via registry central ---
// Este modal é montado via `v-if` pelo CampoBusca, então reserva o z-index de
// forma SÍNCRONA no setup (evita um frame na camada base antes do reserve) e
// libera no onUnmounted. A prop `zIndexBase`, quando informada, atua como piso.
const tokenZIndex = ref(null)
const zIndexReservado = ref(null)
const zIndexReal = computed(() => zIndexReservado.value ?? props.zIndexBase ?? BASE_ZINDEX)

const reservaInicial = reservarZIndex(props.zIndexBase)
tokenZIndex.value = reservaInicial.token
zIndexReservado.value = reservaInicial.zIndex

// --- Estado de arrasto (mesmo padrão do ModalFormulario) ---
const modalRef = ref(null)
// GUARDIÃO (centralização): posX/posY iniciam como null. Enquanto null, o
// modal permanece centralizado por CSS no backdrop (display: flex) — zero
// flash no canto da tela e fallback seguro caso centralizarModal() não rode.
const posX = ref(null)
const posY = ref(null)
const dragging = ref(false)
// GUARDIÃO: true quando o usuário posicionou o modal manualmente via arrasto.
// A partir daí, centralizarModal() não sobrescreve mais a posição manual.
const arrastadoManualmente = ref(false)
const dragOffset = ref({ x: 0, y: 0 })

const modalStyle = computed(() => {
  if (!props.draggable) return {}
  // Enquanto não posicionado, mantém o fluxo flex do backdrop (centralizado por CSS)
  if (posX.value === null || posY.value === null) return {}
  return {
    position: 'fixed',
    left: `${posX.value}px`,
    top: `${posY.value}px`,
    transform: 'none',
    margin: '0'
  }
})

const centralizarModal = () => {
  if (!props.draggable || !modalRef.value) return
  // Preserva a posição manual: depois que o usuário arrastou, não re-centraliza
  if (arrastadoManualmente.value) return
  const rect = modalRef.value.getBoundingClientRect()
  posX.value = (window.innerWidth - rect.width) / 2
  posY.value = Math.max((window.innerHeight - rect.height) / 2, 20)
}

const iniciarArrasto = (e) => {
  if (!props.draggable || !modalRef.value) return
  e.preventDefault()
  dragging.value = true
  arrastadoManualmente.value = true
  const rect = modalRef.value.getBoundingClientRect()
  // Se ainda estava centralizado por CSS (posX/posY null), "pega" a posição
  // atual para iniciar o arrasto sem salto visual.
  if (posX.value === null || posY.value === null) {
    posX.value = rect.left
    posY.value = rect.top
  }
  dragOffset.value = { x: e.clientX - rect.left, y: e.clientY - rect.top }
  document.body.style.userSelect = 'none'
  document.body.style.pointerEvents = 'none'
  document.addEventListener('mousemove', mover)
  document.addEventListener('mouseup', pararArrasto)
}

const mover = (e) => {
  if (!dragging.value) return
  posX.value = e.clientX - dragOffset.value.x
  posY.value = e.clientY - dragOffset.value.y
}

const pararArrasto = () => {
  dragging.value = false
  document.body.style.userSelect = ''
  document.body.style.pointerEvents = ''
  document.removeEventListener('mousemove', mover)
  document.removeEventListener('mouseup', pararArrasto)
}

const limparListenersArrasto = () => {
  document.removeEventListener('mousemove', mover)
  document.removeEventListener('mouseup', pararArrasto)
  document.body.style.userSelect = ''
  document.body.style.pointerEvents = ''
}

const emit = defineEmits(['fechar', 'item-selecionado', 'itens-selecionados'])

// --- Tamanho dinâmico do modal ---
// Permite ao usuário aumentar/diminuir o modal ciclando entre os tamanhos
// disponíveis (xs → sm → lg → xl → xxl). A prop `tamanho` (ou configuracao.tamanho)
// define o tamanho inicial; os botões do header alteram `tamanhoAtual` em runtime.
const tamanhosDisponiveis = ['xs', 'sm', 'lg', 'xl', 'xxl']
const tamanhoAtual = ref(props.tamanho || props.configuracao?.tamanho || 'lg')
const tamanhoAtualIndex = computed(() => tamanhosDisponiveis.indexOf(tamanhoAtual.value))

const itensSelecionados = ref(new Map())

// Inicializa itensSelecionados com os itens já selecionados (quando multi-select)
if (props.itensJaSelecionados.length > 0) {
  const idFieldVal = props.configuracao.idField || 'id'
  for (const item of props.itensJaSelecionados) {
    const id = item[idFieldVal]
    if (id !== undefined && id !== null) {
      itensSelecionados.value.set(String(id), item)
    }
  }
}
const idField = computed(() => props.configuracao.idField || 'id')

/** Seleção viva do modal (Map) como lista reativa — alimenta o rodapé e reflete marcações/desmarcações */
const itensSelecionadosLista = computed(() => Array.from(itensSelecionados.value.values()))

/** Set de IDs dos itens já selecionados (fora do modal), para lookup rápido */
const jaSelecionadosIds = computed(() => {
  const ids = new Set()
  const idFieldVal = props.configuracao.idField || 'id'
  for (const item of props.itensJaSelecionados) {
    const id = item[idFieldVal]
    if (id !== undefined && id !== null) {
      ids.add(String(id))
    }
  }
  return ids
})

/** Função rowClass para AdminTable: destaca linhas que já estão selecionadas */
const rowClassJaSelecionado = (row) => {
  if (!row) return ''
  const rowId = String(row[idField.value])
  return jaSelecionadosIds.value.has(rowId) ? 'ja-selecionado' : ''
}

// Alias do composable (o ModalDeBusca mantém um wrapper local com a mesma
// assinatura `(itens)` e delega a resolução para o composable compartilhado).
const { resolverListasEmLote: resolverListasEmLoteDoComposable } = useResolverListas()

const valoresFiltro = ref({})
const opcoesSelect = ref({})
const resultados = ref([])
const isLoading = ref(false)
const erroBusca = ref(null)

// --- Sorting (AdminTable) ---
const sortField = ref('')
const sortOrder = ref('')

// --- Paginação ---
const paginacao = ref({
  CurrentPage: 1,
  TotalPages: 0,
  PageSize: 10,
  TotalCount: 0,
  HasPrevious: false,
  HasNext: false
})

const opcoesTamanho = computed(() => {
  const base = paginacao.value.PageSize || 10
  return [base, base + 10, base + 20, base + 40]
})

const tamanhoClass = computed(() => {
  const tamanho = tamanhoAtual.value
  if (tamanho === 'xs') return 'modal-xs'
  if (tamanho === 'sm') return 'modal-sm'
  if (tamanho === 'xl') return 'modal-xl'
  if (tamanho === 'xxl') return 'modal-xxl'
  return '' // default LG
})

// --- Mapeamento de colunas do config para AdminTable ---
// Se o dataField da coluna for um campo Lst* (ex: lstNaturezaItemAtendido),
// redireciona automaticamente para o campo resolvido {campo}Texto
// (ex: lstNaturezaItemAtendidoTexto), que contém o textoLista em vez do código bruto.
const colunasMapeadas = computed(() => {
  const itens = resultados.value
  // Mapeia quais campos Lst* foram resolvidos (possuem {campo}Texto) em
  // QUALQUER item, não apenas no primeiro. Isso evita o bug de um campo
  // com valor vazio no primeiro item impedir a resolução para todos.
  // GUARDIÃO: Só considera campos Lst* que são colunas do grid, ignorando
  // campos extras que vieram da API (ex: lstStatus, lstCategoria) para
  // evitar break prematuro antes de resolver todos os campos do grid.
  const camposGridLst = new Set(
    (props.configuracao.colunasGrid || [])
      .filter(c => /^[lL]st[A-Z]/.test(c.dataField))
      .map(c => c.dataField)
  )
  const camposResolvidos = new Set()
  if (Array.isArray(itens) && itens.length > 0) {
    const totalLst = camposGridLst.size
    for (const item of itens) {
      if (!item || typeof item !== 'object') continue
      for (const key of Object.keys(item)) {
        if (camposGridLst.has(key)) {
          const fieldTexto = `${key}Texto`
          if (item[fieldTexto] !== undefined) {
            camposResolvidos.add(key)
          }
        }
      }
      if (camposResolvidos.size >= totalLst) break
    }
  }

  const colunas = (props.configuracao.colunasGrid || []).map(col => {
    let field = col.dataField
    if (field && /^[lL]st[A-Z]/.test(field) && camposResolvidos.has(field)) {
      field = `${field}Texto`
    }
    return {
      field,
      label: col.header,
      width: col.width,
      sortable: col.sortable !== undefined ? col.sortable : true,
      resizable: col.resizable !== undefined ? col.resizable : true,
      allowHtml: col.allowHtml === true,
      formatter: (value, row) => {
        // Se tem formatter customizado definido na config, usa ele primeiro
        if (col.formatter) {
          return col.formatter(value, row)
        }
        // Converte valores booleanos para Sim/Não
        if (typeof value === 'boolean') {
          return value ? 'Sim' : 'Não'
        }
        return value
      },
      align: col.align || null,
      class: col.class || null,
      minWidth: col.minWidth || 80
    }
  })

  // Se for seleção múltipla, adiciona coluna de checkbox no início
  if (props.selecaoMultipla) {
    colunas.unshift({
      field: '_checkbox',
      label: '',
      width: 40,
      sortable: false,
      resizable: false,
      slotName: 'checkbox',
      align: 'center'
    })
  }

  return colunas
})

// --- Ordenação local (quando dadosLocais) ---
const resultadosOrdenados = computed(() => {
  if (!sortField.value || !sortOrder.value) return resultados.value
  const data = [...resultados.value]
  data.sort((a, b) => {
    const valA = a[sortField.value]
    const valB = b[sortField.value]
    if (valA == null) return 1
    if (valB == null) return -1
    const cmp = typeof valA === 'string'
      ? valA.localeCompare(valB)
      : valA - valB
    return sortOrder.value === 'asc' ? cmp : -cmp
  })
  return data
})

// --- Lifecycle ---
onMounted(async () => {
  // Centraliza ANTES de qualquer operação assíncrona (ex: carregar opções de
  // selects), garantindo que o modal já abra no centro desde o primeiro frame.
  // O backdrop mantém o flexbox até o posicionamento ser definido (posX/posY null),
  // então mesmo havendo delay a centralização por CSS já vale.
  await nextTick()
  centralizarModal()

  if (props.configuracao?.camposFiltro) {
    for (const filtro of props.configuracao.camposFiltro) {
      // GUARDIÃO: Respeita o valor predefinido caso tenha sido enviado pela configuração!
      valoresFiltro.value[filtro.model] = filtro.value !== undefined ? filtro.value : ''
      if (filtro.tipo === 'date') {
        valoresFiltro.value[filtro.model + '_op'] = '='
      }

      // Carregar opções do select dinamicamente
      if (filtro.tipo === 'select' && filtro.optionsEndpoint) {
        try {
          const res = await api.get(`/${filtro.optionsEndpoint}`)
          if (res.data) {
            // Aceita tanto array direto quanto objecto com propriedade items/data dependendo da API
            const dataArr = Array.isArray(res.data) ? res.data : (res.data.items || res.data.data || [])
            // Se o filtro fornecer um optionsMapper customizado, usa-o; caso contrário, usa o mapeamento padrão
            const mapper = filtro.optionsMapper || ((item) => ({
              value: item.idListaSistemaItem || item.idListaClienteItem || item.id || item.textoLista,
              label: item.textoLista || item.nome || item.descricao || item.label || 'Sem Nome'
            }))
            opcoesSelect.value[filtro.model] = dataArr.map(mapper)
          }
        } catch (e) {
          console.error(`Erro ao carregar opções para ${filtro.model}:`, e)
          opcoesSelect.value[filtro.model] = []
        }
      } else if (filtro.tipo === 'select' && filtro.options) {
        opcoesSelect.value[filtro.model] = filtro.options
      }
    }
  }

  // Auto-foco no primeiro campo de filtro visível
  await nextTick()
  const primeiroFiltro = props.configuracao?.camposFiltro?.find(f => f.tipo !== 'hidden')
  if (primeiroFiltro) {
    const el = document.getElementById(`filtro-${primeiroFiltro.model}`)
    if (el) el.focus()
  }

  await executarBusca(1)
  // Re-centraliza após a busca: o grid (resultados) pode alterar a altura do
  // modal, reposicionando-o no centro. O nextTick garante que a medição do
  // rect aconteça com o grid já renderizado (altura final). Se o usuário já
  // arrastou o modal, a posição manual é preservada (arrastadoManualmente).
  await nextTick()
  centralizarModal()
})

// --- Event Handlers ---
const onSortChange = ({ field, order }) => {
  sortField.value = field
  sortOrder.value = order
  // Para busca via API, re-executa com parâmetros de ordenação
  if (!props.configuracao.dadosLocais) {
    executarBusca(1)
  }
}

const onRowClick = ({ row }) => {
  if (props.selecaoMultipla) {
    toggleItemSelecao(row)
  } else {
    selecionarItem(row)
  }
}

const onPageSizeChange = (event) => {
  paginacao.value.PageSize = Number(event.target.value)
  executarBusca(1)
}

/**
 * Resolve campos Lst* em lote para um array de itens.
 * Delega ao composable useResolverListas (com cache compartilhado),
 * injetando {campo}Texto com o textoLista resolvido para exibição no grid.
 */
const resolverListasEmLote = async (itens) => {
  await resolverListasEmLoteDoComposable(itens, props.configuracao?.tabela)
}

const executarBusca = async (pageNumber = 1) => {
  if (pageNumber < 1) return
  isLoading.value = true
  erroBusca.value = null

  try {
    const params = new URLSearchParams()

    params.append('pageNumber', pageNumber)
    params.append('pageSize', paginacao.value.PageSize)

    // Anexa parâmetros de ordenação para API remota
    if (sortField.value && sortOrder.value) {
      params.append('sortField', sortField.value)
      params.append('sortOrder', sortOrder.value)
    }

    // GUARDIÃO: 1. ANEXAR FILTROS FIXOS (IMUTÁVEIS - Ex: isInstFinanceira)
    if (props.configuracao?.filtrosFixos) {
      Object.entries(props.configuracao.filtrosFixos).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          params.append(key, value)
        }
      })
    }

    // 2. ANEXAR FILTROS DINÂMICOS (DA UI)
    // GUARDIÃO: Usa params.set() para que o valor escolhido pelo usuário
    // sobrescreva qualquer filtro fixo com a mesma chave (ex: lstTipoConta
    // pode vir tanto em filtrosFixos quanto em camposFiltro).
    if (props.configuracao?.camposFiltro) {
      props.configuracao.camposFiltro.forEach(filtro => {
        const model = filtro.model
        const value = valoresFiltro.value[model]
        // Modificado para garantir que não mandamos strings vazias, mas permitimos booleanos
        if (value !== '' && value !== null && value !== undefined) {
          params.set(model, value)
          if (filtro.tipo === 'date') {
            const operator = valoresFiltro.value[model + '_op']
            if (operator) {
              params.set(model + '_op', operator)
            }
          }
        }
      })
    }

    // GUARDIÃO: Usa api.get para respeitar os interceptors globais e resolver o CORS no Frontend
    if (props.configuracao.dadosLocais && Array.isArray(props.configuracao.dadosLocais)) {
      // BUSCA LOCAL
      let filtrados = [...props.configuracao.dadosLocais]

      if (props.configuracao?.camposFiltro) {
        props.configuracao.camposFiltro.forEach(filtro => {
          const val = valoresFiltro.value[filtro.model]
          if (val !== '' && val !== null && val !== undefined) {
            const termo = String(val).toLowerCase()
            filtrados = filtrados.filter(item => {
              return Object.values(item).some(v => String(v).toLowerCase().includes(termo))
            })
          }
        })
      }

      // Ordem padrão do grid: por sequenciaLista quando não há ordenação ativa do usuário
      if (!sortField.value || !sortOrder.value) {
        filtrados.sort((a, b) => {
          const seqA = a?.sequenciaLista ?? a?.SequenciaLista
          const seqB = b?.sequenciaLista ?? b?.SequenciaLista
          const hasA = seqA !== undefined && seqA !== null
          const hasB = seqB !== undefined && seqB !== null
          if (hasA && hasB) return seqA - seqB
          if (hasA) return -1
          if (hasB) return 1
          return 0
        })
      }

      const total = filtrados.length
      const inicio = (pageNumber - 1) * paginacao.value.PageSize
      resultados.value = filtrados.slice(inicio, inicio + paginacao.value.PageSize)

      paginacao.value = {
        CurrentPage: pageNumber,
        TotalCount: total,
        PageSize: paginacao.value.PageSize,
        TotalPages: Math.ceil(total / paginacao.value.PageSize),
        HasPrevious: pageNumber > 1,
        HasNext: (pageNumber * paginacao.value.PageSize) < total
      }
    } else {
      // BUSCA VIA API
      const response = await api.get(`/${props.configuracao.endpointApi}?${params.toString()}`)
      const dados = response.data

      // Resolve campos Lst* ANTES de atribuir ao ref reativo,
      // para que o Proxy do Vue já capture os campos {campo}Texto resolvidos
      await resolverListasEmLote(dados)

      resultados.value = dados

      if (response.headers['x-pagination']) {
        paginacao.value = JSON.parse(response.headers['x-pagination'])
      }
    }
  } catch (error) {
    console.error('Erro ao buscar dados:', error)
    console.log('[DEBUG ModalDeBusca] catch atingido. onShowNotification é function?', typeof props.onShowNotification)
    erroBusca.value = 'Não foi possível carregar os dados. Tente novamente.'
    paginacao.value = {}

    // Extrai mensagem do backend se disponível, senão usa mensagem genérica
    const mensagem = error?.response?.data?.message ||
      error?.response?.data?.title ||
      'Não foi possível carregar os dados. Tente novamente.'

    console.log('[DEBUG ModalDeBusca] mensagem extraída:', mensagem)

    if (typeof props.onShowNotification === 'function') {
      console.log('[DEBUG ModalDeBusca] chamando onShowNotification callback')
      props.onShowNotification({ message: mensagem, type: 'error' })
    } else {
      console.log('[DEBUG ModalDeBusca] onShowNotification NÃO é function, fallback para emit')
      emit('show-notification', { message: mensagem, type: 'error' })
    }
  } finally {
    isLoading.value = false
  }
}

const toggleItemSelecao = (item) => {
  const id = String(item[idField.value])
  const novoMap = new Map(itensSelecionados.value)
  if (novoMap.has(id)) {
    novoMap.delete(id)
  } else {
    novoMap.set(id, item)
  }
  itensSelecionados.value = novoMap
}

const confirmarSelecao = () => {
  const itens = Array.from(itensSelecionados.value.values())
  emit('itens-selecionados', itens)
  fechar()
}

const selecionarItem = (item) => {
  emit('item-selecionado', item)
}

const fechar = () => {
  itensSelecionados.value = new Map()
  emit('fechar')
}

// --- Controles de tamanho do modal ---
const aumentarTamanho = async () => {
  const idx = Math.min(tamanhoAtualIndex.value + 1, tamanhosDisponiveis.length - 1)
  tamanhoAtual.value = tamanhosDisponiveis[idx]
  await reCentralizarAposMudancaTamanho()
}

const diminuirTamanho = async () => {
  const idx = Math.max(tamanhoAtualIndex.value - 1, 0)
  tamanhoAtual.value = tamanhosDisponiveis[idx]
  await reCentralizarAposMudancaTamanho()
}

// Sempre re-centraliza ao mudar tamanho, ignorando o arrasto manual:
// o rect do modal muda com a nova classe (max-width), então a posição
// anterior deixou de ser válida. Reseta arrastadoManualmente para que o
// centralizarModal() não preserve a posição antiga.
const reCentralizarAposMudancaTamanho = async () => {
  await nextTick()
  arrastadoManualmente.value = false
  centralizarModal()
}

// --- Handler para filtro do tipo listabusca (CampoBuscaLista) ---
const onFiltroListaSelecionado = () => {
  // O CampoBuscaLista já atualiza o v-model (valoresFiltro[model]) via emit
  // Dispara a busca automaticamente
  executarBusca(1)
}

// --- Handler para filtro do tipo campobusca (CampoBusca) ---
const onFiltroCampoBuscaSelecionado = () => {
  // O CampoBusca já atualiza o v-model (valoresFiltro[model]) via emit
  // Dispara a busca automaticamente
  executarBusca(1)
}

// --- Fechar ao pressionar Escape ---
const onKeyDown = (event) => {
  if (event.key === 'Escape') {
    fechar()
  }
}

onMounted(() => {
  document.addEventListener('keydown', onKeyDown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', onKeyDown)
  limparListenersArrasto()
  liberarZIndex(tokenZIndex.value)
  tokenZIndex.value = null
  zIndexReservado.value = null
})
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-backdrop-draggable {
  display: block;
}

/* Base fluida e adaptável */
.modal-container {
  width: 90%;
  max-width: 900px;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.modal-xs { max-width: 340px; }
.modal-sm { max-width: 500px; }
.modal-xl { max-width: 1140px; }
.modal-xxl { max-width: 1400px; }

/* O Cabeçalho mantém a âncora visual da marca */
.modal-header {
  padding: 1rem 1.5rem;
  background-color: #34495E;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid #1f2d3a;
  flex-shrink: 0;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

/* Botões Aumentar/Diminuir tamanho do modal — seguem o MESMO padrão visual
   do X de fechar (btn-close btn-close-white): ghost, sem borda, ícone branco,
   opacity reduzida até o hover. O btn-close usa background-image (SVG do X),
   que é removido aqui para dar lugar ao ícone Bootstrap (bi). */
.modal-size-btn {
  background-image: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  line-height: 1;
  width: 1.25em;
  height: 1.25em;
  padding: 0.25em;
}

.modal-size-btn:disabled {
  opacity: 0.25;
}

.cursor-grab { cursor: grab; }
.cursor-grabbing { cursor: grabbing; user-select: none; }

.modal-title {
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0;
  cursor: text;
  user-select: text;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
}

.modal-footer {
  padding: 1rem 1.5rem;
  background-color: var(--bs-body-bg);
  border-top: 1px solid var(--bs-border-color-translucent);
  flex-shrink: 0;
  display: flex;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

/* Filtros com fundo adaptável */
.filtros-container {
  padding: 1.5rem;
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  background-color: var(--bs-tertiary-bg);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.filtros-corpo {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}

.filtros-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  flex: 1;
  min-width: 0;
}

.filtro-item {
  flex: 1 1 200px;
  min-width: 180px;
}

.filtro-data {
  flex: 1 1 280px;
  min-width: 240px;
}

.filtro-operador {
  max-width: 80px;
  flex: 0 0 auto;
}

.filtro-botao-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 0;
  align-self: flex-end;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
}

/* --- ESTILOS DE GRELHA INJETADOS (VIA :DEEP) --- */
:deep(.admin-table-container) {
  background-color: transparent;
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
}

:deep(.admin-table) {
  width: 100%;
  border-collapse: collapse;
  background-color: transparent;
  color: var(--bs-body-color);
}

:deep(.admin-table thead th) {
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-heading-color);
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid var(--bs-border-color-translucent);
}

:deep(.admin-table th) {
  padding: 0.9rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--bs-border-color-translucent);
  vertical-align: middle;
}

:deep(.admin-table td) {
  padding: 0.9rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--bs-border-color-translucent);
  vertical-align: middle;
  white-space: nowrap;
}

:deep(.admin-table tbody tr:last-child td) {
  border-bottom: none;
}

:deep(.admin-table tbody tr:hover td) {
  background-color: var(--bs-secondary-bg);
  cursor: pointer;
}

.tag-badge {
  background: var(--bs-tertiary-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

/* --- Destaque de linhas já selecionadas no grid (Camada 3) --- */
:deep(.admin-table tbody tr.ja-selecionado td) {
  background-color: rgba(40, 167, 69, 0.08) !important;
  box-shadow: inset 3px 0 0 var(--bs-success, #28a745);
}

:deep(.admin-table tbody tr.ja-selecionado:hover td) {
  background-color: rgba(40, 167, 69, 0.12) !important;
}

/* --- Mini-tabela de itens já selecionados no footer (Camada 2) --- */
.ja-selecionados-table {
  max-height: 120px;
  overflow-y: auto;
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.375rem;
  background-color: rgba(40, 167, 69, 0.03);
}

.ja-selecionados-table thead th {
  position: sticky;
  top: 0;
  background-color: var(--bs-tertiary-bg);
  border-bottom: 1px solid var(--bs-border-color-translucent);
  padding: 0.375rem 0.5rem;
  white-space: nowrap;
}

.ja-selecionados-table tbody td {
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
  border-bottom: 1px solid var(--bs-border-color-translucent);
}

.ja-selecionados-table tbody tr:last-child td {
  border-bottom: none;
}
</style>
